const drawerHeaderTokens = ({ colors, space, borders }) => ({
  colors: {
    bg: colors.neutral['0'],
    color: colors.neutral['90'],
    arrow: colors.primary['50'],
  },
  space: {
    py: space[4],
    px: space[4],
  },
  borders: `${borders[1]} ${colors.neutrals[5]}`,
});

export default drawerHeaderTokens;
